import { LOCALES } from 'i18n/locales';

export const selectFeatureIntl = {
    [LOCALES.ENGLISH]: {
        'selectFeature.redactedAssetHeader': 'Hidden asset',
        'selectFeature.button.previous': 'Previous',
        'selectFeature.button.next': 'Next',
        'selectFeature.button.close': 'Close',
        'selectFeature.stepXofY': '{x} of {y}'
    },
    [LOCALES.WELSH]: {
        'selectFeature.redactedAssetHeader': '[Hidden asset]',
        'selectFeature.button.previous': 'Blaenorol',
        'selectFeature.button.next': 'Nesaf',
        'selectFeature.button.close': 'Cau',
        'selectFeature.stepXofY': '{x} o {y}'
    }
};
